module.exports = __webpack_public_path__ + "img/85.9a949d74.jpg";